import React from 'react'
import PropTypes from 'prop-types'

import {
  TableRow,
  TableHeaderColumn,
} from 'material-ui/Table'
import styles from './styles.css'

export default function ApptTypesTableHeader({ hasPatientPortal }) {
  const tableHeader = [
    {
      message: 'Appointment Types',
      id: 1,
    },
    {
      message: 'New Patient Appointments',
      id: 2,
    },
    {
      message: 'Existing Patient Appointments',
      id: 3,
    },
  ]
  if (hasPatientPortal) {
    tableHeader.push({
      message: 'Window After Next Visit Date',
      id: 4,
    })
  }
  return (
    <TableRow>
      {tableHeader.map(data => (
        <TableHeaderColumn
          key={data.id}
          style={{ padding: '0px', textAlign: 'center' }}
        >
          <span className={styles.tableHeaderLabel}>{data.message}</span>
        </TableHeaderColumn>
      ))}
    </TableRow>
  )
}

ApptTypesTableHeader.propTypes = {
  hasPatientPortal: PropTypes.bool.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/ApptTypesTableHeader.js